import { Factory } from '@octopus-do/octopus-project-core'

import { InitialColorIds } from '../colors'
import { InitialNodeIds } from './initialNodeIds'

export const InitialRootNode = Factory.node({
  id: InitialNodeIds.main.root,
  title: 'Page',
  colorId: InitialColorIds.default,
})

export const InitialChildNodes = [
  Factory.node({
    id: InitialNodeIds.main.page1,
    title: 'Page',
    colorId: InitialColorIds.default,
  }),
  Factory.node({
    id: InitialNodeIds.main.page2,
    title: 'Page',
    colorId: InitialColorIds.default,
  }),
  Factory.node({
    id: InitialNodeIds.main.page3,
    title: 'Page',
    colorId: InitialColorIds.default,
  }),
]

export const InitialSecondaryNodes = [
  Factory.node({
    id: InitialNodeIds.secondary.cookies,
    title: 'Cookies',
    colorId: InitialColorIds.default,
  }),
  Factory.node({
    id: InitialNodeIds.secondary.error404,
    title: '404 Error',
    colorId: InitialColorIds.default,
  }),
]
